import { Plan } from '@/shared/types/Billing';

import { CATEGORY_ORDER } from '../constants';
import { PlansByCategory } from '../types';

const sortByCategoryAndBundlePosition = (plans: Plan[]) =>
  plans.sort((a, b) => {
    const categoryA = CATEGORY_ORDER[a.category as keyof typeof CATEGORY_ORDER] || 0;
    const categoryB = CATEGORY_ORDER[b.category as keyof typeof CATEGORY_ORDER] || 0;

    if (categoryA === categoryB) {
      return a.metadata.bundle_position - b.metadata.bundle_position;
    }

    return categoryA - categoryB;
  });

const getBundles = (plans: Plan[]) =>
  plans.reduce<PlansByCategory[]>((acc, plan) => {
    const { name, category, description } = plan;
    const prevPlan = acc[acc.length - 1];

    if (prevPlan?.category === category) {
      prevPlan.plans.push(plan);
    } else {
      acc.push({ name, category, description, plans: [plan] });
    }

    return acc;
  }, []);

export const getTransformedPlans = (plans: Plan[]) => {
  const sortedPlans = sortByCategoryAndBundlePosition(plans);

  return getBundles(sortedPlans);
};
